// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"678":"component---src-pages-index-js","883":"component---src-pages-404-js"}[chunkId] + "-" + {"678":"22c6192609e8daa54353","883":"d67d1dc2781d93342f19"}[chunkId] + ".js";
};